import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";

import "./DeleteAccount.scss";
import Spinner from "../../component/spinner/Spinner";
import Header from "../../component/header/Header";
import Aside from "../../component/aside/Aside";
import Footer from "../../component/footer/Footer2";
import { deleteCustomerCall } from "../../redux/slice/deleteCustomer";
import { useDispatch } from "react-redux";

const DeleteAccount = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("v-pills-home");
  const [isAccepted, setIsAccepted] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const handleCheckboxChange = (event) => {
    setIsAccepted(event.target.checked);
  };
  const breadcrumbs = [
    <Link
      underline="hover"
      key="1"
      color="inherit"
      onClick={() => navigate("/home")}
      sx={{
        fontSize: "12px",
        fontWeight: "300",
        lineHeight: "12px",
        color: "#1D1D1B",
      }}
    >
      Home
    </Link>,
    <Typography
      key="3"
      sx={{
        fontSize: "12px",
        fontWeight: "700",
        lineHeight: "15px",
        color: "#1D1D1B",
      }}
    >
      Delete Account
    </Typography>,
  ];
  const breadcrumbsMobile = [
    <Link
      underline="hover"
      key="1"
      color="inherit"
      onClick={() => navigate("/home")}
      sx={{
        fontSize: "12px",
        fontWeight: "300",
        lineHeight: "12px",
        color: "#A9A9A9",
      }}
    >
      Home
    </Link>,
    <Typography
      key="3"
      sx={{
        fontSize: "12px",
        fontWeight: "700",
        lineHeight: "15px",
        color: "#ffffff",
      }}
    >
      Delete Account
    </Typography>,
  ];

  const AreYouSureModal = (props) => {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const handleDelete = async () => {
      setLoading(true);
      try {
        const result = await dispatch(deleteCustomerCall());
        if (result?.payload?.createdId) {
          sessionStorage.clear();
          localStorage.clear();
          navigate("/");
        } else {
          toast.error(
            result?.payload?.errors?.[0]?.message ||
              result?.payload?.message ||
              "Failed to delete account"
          );
        }
      } catch (e) {
        console.error(e);
        toast.error("Failed to delete account");
      } finally {
        setLoading(false);
      }
    };
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 600); // Adjust breakpoint as needed
      };

      // Check screen size on component mount
      handleResize();

      // Add event listener for window resize
      window.addEventListener("resize", handleResize);

      // Clean up event listener on unmount
      return () => window.removeEventListener("resize", handleResize);
    }, []);
    return (
      <>
        <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered={!isMobile}
          className="conditional-modal slide-up-modal"
        >
          <Button
            type="button"
            className="custom-close mobile-close mobile-close-del"
            aria-label="Close"
            onClick={() => {
              props.onHide();
            }}
          >
            <span aria-hidden="true">&times;</span>
          </Button>

          <Modal.Header>
            <Modal.Title
              id="contained-modal-title-vcenter"
              className="text-center w-100"
            >
              Are you sure you want to delete your account?
            </Modal.Title>
          </Modal.Header>

          <Modal.Body></Modal.Body>

          <Modal.Footer>
            <Button onClick={handleDelete}>{loading ? <Spinner /> : "Yes"}</Button>

            <Button
              onClick={() => {
                props.onHide();
              }}
            >
              No
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  };
  return (
    <>
      <Header activeTab={activeTab} setActiveTab={setActiveTab} />
      <div className="home">
        <div
          className="container pt-5 in-mobile desktop_content"
          style={{ paddingBottom: "40px" }}
        >
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
          >
            {breadcrumbs}
          </Breadcrumbs>
        </div>
        <div className="sidebar">
          <div className="container">
            <div className="row">
              <div className="col-lg-4  col-md-4 desktop_content">
                <Aside activeTab={activeTab} setActiveTab={setActiveTab} />
              </div>
              <div className="col-lg-8 col-md-8 in-mobile">
                <div className="tabs">
                  <div className="tab_content">
                    <div className="tab-content" id="v-pills-tabContent">
                      <div
                        className=""
                        id="v-pills-offers"
                        role="tabpanel"
                        aria-labelledby="v-pills-offers-tab"
                        tabIndex="0"
                      >
                        <div className="container1">
                          <div className="title-container">
                            <div className="container pt-5 in-mobile mobile_content">
                              <Breadcrumbs
                                separator={
                                  <NavigateNextIcon
                                    fontSize="small"
                                    sx={{ color: "#A9A9A9" }}
                                  />
                                }
                                aria-label="breadcrumb"
                              >
                                {breadcrumbsMobile}
                              </Breadcrumbs>
                            </div>
                            <h2>Delete Account</h2>
                          </div>

                          <div className="delete-terms-container">
                            <h5>We are sad to see you go.</h5>
                            <p>
                              Please take note of the following details prior to
                              deleting your account:
                            </p>
                            <ol>
                              <li>
                                Account deletion is permanent and irreversible.
                                After successful deletion, you will not be able
                                to login and view your previous account history.
                              </li>
                              <li>
                                All unutilised points and offers will be
                                forfeited.
                              </li>
                              <li>
                                Your personal data will be deleted from the
                                system within 1 working day.
                              </li>
                              <li>
                                DLF Malls will still have the right to retain your
                                transaction data for finance and audit purposes
                                after successful deletion of your account.
                              </li>
                            </ol>
                            <div className="pad">
                              <input
                                type="checkbox"
                                id="flexCheckDefault"
                                className="form-check-input"
                                name="flexCheckDefault"
                                checked={isAccepted}
                                onChange={handleCheckboxChange}
                              />
                              <label htmlFor="flexCheckDefault">
                                {" "}
                                By Continuing, I agree to Terms and Conditions
                              </label>
                            </div>
                            <div className="pad">
                              <button
                                disabled={!isAccepted}
                                style={{
                                  backgroundColor: `${
                                    isAccepted ? "#000" : "gray"
                                  }`,
                                }}
                                onClick={() => setModalShow(true)}
                              >
                                Submit
                              </button>
                              <AreYouSureModal
                                show={modalShow}
                                onHide={() => setModalShow(false)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footerMobPending"></div>
      <Footer selected="home" />
    </>
  );
};

export default DeleteAccount;
